module.exports = __webpack_public_path__ + "img/SummaryBannerMobile.7d415e65.png";